var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex" }, [
    _c("div", [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.hours,
                expression: "hours",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.hours = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.reserveHours, function (h) {
            return _c("option", { domProps: { value: h.hours } }, [
              _vm._v(_vm._s(h.title)),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-group-append" },
          [
            _c("LoadingButton", {
              attrs: {
                title: _vm.saveAfterOrderUpdate
                  ? "Будет установлена после сохранения заявки"
                  : "Установить",
                className: !_vm.saveAfterOrderUpdate
                  ? "btn btn-outline-info"
                  : "btn btn-info",
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
                onClick: () => _vm.saveReserve(),
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.$editNewOrder.is_reserved
      ? _c(
          "div",
          { staticClass: "align-self-center m-0 ml-2 alert alert-info" },
          [
            _c("p", [_vm._v("Заявка в резерве")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("до "),
              _c("strong", [
                _vm._v(_vm._s(_vm.printDate(_vm.$editNewOrder.reserved_till))),
              ]),
              _vm._v(" (" + _vm._s(_vm.printRemain()) + ")"),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Поставить заявку в "),
      _c("strong", [_vm._v("резерв")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }